import { render } from "./stock_taking_report.vue?vue&type=template&id=768da65b&scoped=true"
import script from "./stock_taking_report.vue?vue&type=script&lang=js"
export * from "./stock_taking_report.vue?vue&type=script&lang=js"

import "./stock_taking_report.vue?vue&type=style&index=0&id=768da65b&scoped=true&lang=css"

import exportComponent from "/home/denoh/project/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-768da65b"]])

export default __exports__